<template>
  <div class="cat-test-previewer">
    <div v-if="testData && catReady">
      <AdaptiveTestRunner
        :testData="testData"
        :previewMode="true"
        :readOnly="true"
      />
    </div>

    <div v-else-if="loading" class="text-center mt-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading CAT preview...</span>
      </div>
      <p class="mt-3"><i>🐈 Loading CAT test preview…</i></p>
    </div>

    <div v-else-if="error" class="text-center mt-5">
      <div class="alert alert-danger">
        <h4>Erreur de chargement CAT</h4>
        <p>{{ error }}</p>
        <small>Test ID: {{ testId }}</small>
        <small>API URL: {{ apiUrl }}</small>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script setup>
import AdaptiveTestRunner from './AdaptiveTestRunner.vue';
import Footer from '../views/footer.vue';
import { useRoute } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import api from '../api';

const route = useRoute();
const testData = ref(null);
const loading = ref(true);
const error = ref(null);
const catReady = ref(false);

const testId = route.query.testId;

// Configuration API (réutilise la logique de TestPreviewer)
const isDocker = import.meta.env.VITE_DOCKER_ON === "istrue";

const apiUrl = computed(() => {
  if (!testId) return '';

  if (isDocker) {
    const dockerApiBase = import.meta.env.VITE_TESTRUNNER_API;
    return `${dockerApiBase}/tests/${testId}`;
  } else {
    const devApiBase = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3011';
    return `${devApiBase}/tests/${testId}`;
  }
});

onMounted(async () => {
  try {
    loading.value = true;
    error.value = null;

    console.log("🐈 Chargement du test CAT avec ID:", testId);
    console.log("🔍 Route query params:", route.query);
    
    if (!testId) {
      throw new Error("Aucun ID de test CAT fourni");
    }

    // Vérifier le token preview (même logique que TestPreviewer)
    const previewToken = route.query.previewToken;
    console.log("🔍 Preview token présent:", !!previewToken);
    
    let response;

    if (previewToken) {
      // Mode preview - utiliser la route API /preview
      console.log("🎬 Mode CAT preview détecté, utilisation de /api/tests/:id/preview");
      console.log("🔑 Preview token:", previewToken.substring(0, 20) + "...");
      
      response = await api.get(`/tests/${testId}/preview?previewToken=${previewToken}`);
      console.log("✅ Réponse CAT preview reçue");
      
    } else {
      // Mode normal (ne devrait pas arriver en preview)
      console.log("⚠️ Mode CAT normal détecté (inattendu en preview)");
      response = await api.get(`/tests/${testId}`);
    }

    testData.value = response.data;
    
    // Vérifier que c'est bien un test CAT
    if (testData.value.progression !== 'adaptive') {
      throw new Error("Ce test n'est pas un test CAT adaptatif");
    }
    
    console.log("✅ testData CAT assigné :", testData.value?.title);
    console.log("🐈 Type de progression:", testData.value.progression);
    console.log("📊 Éléments CAT:", testData.value.elements?.length || 0);
    
    // Marquer CAT comme prêt
    catReady.value = true;

  } catch (err) {
    console.error('❌ Erreur de chargement du test CAT :', err);
    console.error('❌ Détails erreur:', err.response?.data);
    error.value = err.response?.data?.message || err.message;
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.cat-test-previewer {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.alert {
  max-width: 600px;
  margin: 0 auto;
}
</style>